<template>
  <input type="text" />
</template>

<script>
/* global */
import $ from 'jquery'
import 'flatpickr'
const Hungarian = require('flatpickr/dist/l10n/hu.js').hu
Hungarian.rangeSeparator = ' - '
require('flatpickr/dist/flatpickr.css')

export default {
  name: 'date-picker',
  props: ['name', 'value', 'mode'],
  data () {
    return {
    }
  },
  mounted () {
    this.picker = $(this.$el).flatpickr({
      mode: this.mode,
      locale: Hungarian,
      dateFormat: 'Y.m.d',
      time_24hr: true,
      onChange: (selectedDates, dateStr, instance) => {
        this.updateValue(selectedDates)
      }
    })
    if (this.value) {
      this.selectDates(this.value)
    }
  },
  watch: {
    value (selectedDates) {
      this.selectDates(selectedDates)
    }
  },
  methods: {
    updateValue (selectedDates) {
      var value

      switch (this.mode) {
        case 'range':
          value = this._getRangeValue(selectedDates)
          break
        default:
          console.log('Invalid mode for date picker: ' + this.mode)
          break
      }

      if (value) {
        this.$emit('input', value)
      }
    },
    _getRangeValue (selectedDates) {
      if (selectedDates && selectedDates.length === 2) {
        return {min: selectedDates[0], max: selectedDates[1]}
      }
      return null
    },
    selectDates (selectedDates) {
      if (this.picker) {
        switch (this.mode) {
          case 'range':
            if (selectedDates.min && selectedDates.max) {
              this.picker.setDate([selectedDates.min, selectedDates.max], false)
            }
            break
          default:
            console.log('Invalid mode for date picker: ' + this.mode)
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// date-picker.vue?6df0b8c4